module.exports = __webpack_public_path__ + "static/img/2-1.211d8b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2-1.png
// module id = iqFh
// module chunks = 1